import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TarificationPage } from './tarification.page';

const routes: Routes = [
  {
    path: '',
    component: TarificationPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TarificationPageRoutingModule {
}
